"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var logger = {
  info: function info() {
    var _console;

    for (var _len = arguments.length, str = new Array(_len), _key = 0; _key < _len; _key++) {
      str[_key] = arguments[_key];
    }

    (_console = console).log.apply(_console, ['[amp-api]'].concat(str));
  },
  warn: function warn() {
    var _console2;

    for (var _len2 = arguments.length, str = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      str[_key2] = arguments[_key2];
    }

    (_console2 = console).warn.apply(_console2, ['[amp-api]'].concat(str));
  },
  error: function error() {
    var _console3;

    for (var _len3 = arguments.length, str = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      str[_key3] = arguments[_key3];
    }

    (_console3 = console).error.apply(_console3, ['[amp-api]'].concat(str));
  }
};
var _default = logger;
exports["default"] = _default;